import { Box, createStyles, makeStyles, Theme, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    secondaryFooter: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      color: '#6f6f6f',
      flex: 1,
      textAlign: "center",
      '& p': {
        fontSize: '0.8rem',
        '& > span' :{
          whiteSpace: 'pre'
        },
        [theme.breakpoints.only('xs')]: {
          fontSize: '0.7rem',
        }
      },
      '& a': {
        color: '#6f6f6f',
        whiteSpace: 'pre'
      },
      '& .MuiTypography-paragraph': {
        marginBottom: theme.spacing(0.5)
      },
      '@media print': {
        color: '#000',
      }
    }
  })
);

const SecondaryFooter: React.FunctionComponent = () => {

    const classes = useStyles();

    return (
        <Box className={classes.secondaryFooter}>
            <Typography paragraph>
                If you'd like further information regarding Zen’s complaint handling procedure, full details can be found in our complaints procedure: &nbsp;
                <a
                    href='https://www.zen.co.uk/contact-us/complaints'
                    target="_blank"
                    rel="noreferrer">
                    https://www.zen.co.uk/contact-us/complaints
                </a>
            </Typography>
            <Typography paragraph>
            If your complaint were to remain open for 8 weeks after raising it with us then you would have right to refer your 
            complaint to CISAS. This is an independent alternative dispute resolution scheme of which we are a member. Their 
            service is free to use, and CISAS' contact details are as follows:
            </Typography>
            <Typography paragraph>
                <strong>Email:</strong>&nbsp;&nbsp;
                <a href="mailto:info@cisas.org.uk?subject=Complaint" rel="noreferrer" target="_blank">info@cisas.org.uk</a> &nbsp;|&nbsp;&nbsp;
            
                <strong>Web:</strong>&nbsp;&nbsp;
                <a href="http://www.cisas.org.uk/" rel="noreferrer" target="_blank">www.cisas.org.uk</a> &nbsp;|&nbsp;&nbsp;

                <span><strong>Tel:</strong>&nbsp; 020 7520 3814</span>
            </Typography>
            <Typography paragraph>
              CISAS International Dispute Resolution Centre, 70 Fleet Street, London, EC4Y 1EU
            </Typography>
        </Box>
    );
  }

  export default SecondaryFooter;